import Slice9Button from "../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Button";
import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";

export default class Slice9ButtonUtil {
    /**
     * 
     * @param {createjs.DisplayObject} slice9ButtonSkin
     */
    static persistInitialState(slice9ButtonSkin) {
        slice9ButtonSkin.initialX = slice9ButtonSkin.x;
        slice9ButtonSkin.initialY = slice9ButtonSkin.y;
        slice9ButtonSkin.initialBounds = slice9ButtonSkin.getBounds();
    }

    /**
     * 
     * @param {Slice9Button} slice9Button 
     * @param {Anchor} anchor 
     */
    static align(slice9Button, anchor) {
        const buttonSkin = slice9Button.skin;
        const newButtonBounds = buttonSkin.getBounds();
        const deltaWidth = (newButtonBounds.x + newButtonBounds.width) - (buttonSkin.initialBounds.x + buttonSkin.initialBounds.width);

        switch (anchor) {
            case Anchor.L:
                buttonSkin.x = buttonSkin.initialX + deltaWidth;
                break;

            case Anchor.R:
                buttonSkin.x = buttonSkin.initialX - deltaWidth;
                break;

            case Anchor.C:
                buttonSkin.x = buttonSkin.initialX;
                break;

            default:
                throw new Error(`Not implemented for anchor ${anchor}`);
        }
    }
}
